module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/model/promo2/components/login-wizard/images/login-denied.png", __webpack_public_path__ + "_/_/_/model/promo2/components/login-wizard/images/login-denied.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/model/promo2/components/login-wizard/images/login-denied.png
// module id = 131
// module chunks = 5